import { AbstractControl } from "@angular/forms";

export function NoWhitespaceValidator(control: AbstractControl) {
  if (control && control.value) {
    const removedSpaces = control.value.split(" ").join("");
    // tslint:disable-next-line: no-unused-expression
    control.value !== removedSpaces && control.setValue(removedSpaces);
  }

  return null;
}
